<template>
  <panel :title="account.shopName">
    <span slot="header-right" class="badge" v-bind:class="isActive()">{{ $t(getStatusLabel(account.active)) }}</span>
    <div>
      <div class="l-row">
        <div class="l-col-12@md img-account">
          <img v-if="account.logo" :src="account.logo"/>
          <i v-if="!account.logo" class="icon-image2 no-photo"/>
        </div>
      </div>
    </div>

    <footer class="c-card__footer u-textLeft l-level">
      <button @click="editAction" class="btn btn--smart btn--sm btn--info l-level__left">
        {{ $t('edit.label') }}
      </button>
      <button @click="modalDeleteAccountFlag = true" slot="header-actions" class="header-right btn btn--smart btn--sm btn--danger l-level__right">
        {{ $t('delete.label') }}
      </button>
    </footer>
    <modal-delete-account v-model="modalDeleteAccountFlag" v-on:confirm="deleteAccount"/>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import ModalDeleteAccount from '@/components/marketplace/shopee/ModalDeleteAccount'
  import api from '@/api/marketplace/shopee'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      modalDeleteAccountFlag: false
    }),
    props: {
      account: {
        type: Object,
        required: true
      }
    },
    methods: {
      isActive () {
        return {
          'success': this.account.active,
          'error': !this.account.active
        }
      },
      getStatusLabel (status) {
        if (status) {
          return 'shopee.accounts.active.label'
        }
        return 'shopee.accounts.inactive.label'
      },
      editAction () {
        return this.$router.push(`/marketplace/shopee/accounts/` + this.account.shopId)
      },
      async deleteAccount () {
        this.loading = true

        await api.deleteAccountByShopId(this.account.shopId)
          .then((productReprocessed) => {
            this.modalDeleteAccountFlag = false
            let message = 'Conta deletada com sucesso!'
            notifier.success(message, 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao deletar conta!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })

        await new Promise(resolve => setTimeout(resolve, 1000))
        window.location.reload()
      }
    },
    components: {
      Panel,
      ModalDeleteAccount
    }
  }
</script>

<style lang="sass" scoped>
  .img-account
    text-align: center

    img
      max-height: 100%
      margin: 5px 0 16px
      max-width: 150px

  .no-photo
    font-size: 150px
    color: darkgrey
</style>



// WEBPACK FOOTER //
// Account.vue?3ed497a3